/**
 * Host serving the invideo-icons bucket at its root (iconfinder icons and the default icon element).
 * Alias of the OAC distribution in front of invideo-icons. null keeps the raw S3 URLs (bucket private).
 */
export const ICONS_CDN_HOST: string | null = 'icons-cdn.invideo.io';

const ICONS_S3_BASE_URL = 'https://s3.ap-south-1.amazonaws.com/invideo-icons/';

/** URL of an invideo-icons object: on the CDN host when one is set, raw S3 otherwise. */
export function iconsUrl(
  key: string,
  cdnHost: string | null = ICONS_CDN_HOST,
): string {
  return cdnHost ? `https://${cdnHost}/${key}` : `${ICONS_S3_BASE_URL}${key}`;
}
